var getBuiltIn=require('../internals/get-built-in');module.exports=getBuiltIn('navigator','userAgent')||'';